/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */
import { YospaceInitializationData, Status } from './model/YospaceInitializationData';
import { AdPlaybackPolicy } from '@quickplay/player-interface';

/**
 * Proxy for the [Session] object that handles [Session] initialization
 * and provides playback URL that conforms to the Yospace infrastructure's
 * Central Streaming Manager (CSM) semantics. This playback URL is subsequently
 * used to build [YospaceAdsPlayer] instance.
 */
export interface YospaceAdsSession {
  /**
   * Instance if session initialization is successful, undefined otherwise
   */
  session: any;

  /**
   * Yospace Ads playback policy
   */
  adsPlaybackPolicy: AdPlaybackPolicy | undefined;

  /**
   * Handles Yospace initlialization logic.
   * @param initializationData the Yospace initialization data
   * Promise resolves with PlaybackUrl, SessionStatus and Failure Reason
   */
  initialize(
    initializationData?: YospaceInitializationData,
    adPlaybackPolicy?: AdPlaybackPolicy,
  ): Promise<{ url: string; status: Status; reason?: string }>;

  /**
   * Shutsdown the session
   */
  shutdown(): void;
}

export enum PlaybackMode {
  /**
   * Represents Live mode
   */
  Live,
  /**
   * Represents Live restart mode
   */
  LiveRestart,
  /**
   * Represents Live catchup mode
   */
  LiveCatchup,
  /**
   * Represents VOD mode
   */
  Vod,
}
